export type ApiResponse<T> = { ok: boolean; data?: T; error?: { code: string; message: string } };

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...init,
    headers: { "Content-Type": "application/json", ...(init?.headers || {}) },
    credentials: "include"
  });
  const json = (await res.json()) as ApiResponse<T>;
  if (!res.ok || !json.ok) throw new Error(json.error?.message || "Request failed");
  return json.data as T;
}
